export const formSytle = function(){
    let inpGroups = document.querySelectorAll('.form .inp-group');
    
    inpGroups.forEach(function(item){
        let eyeHide = <HTMLElement> item.querySelector('.eye-hide');
        let eyeShow = <HTMLElement> item.querySelector('.eye-show');
        console.log(3);

        if (eyeHide && eyeShow){
            let inpItem = item.querySelector('input');

            eyeHide.onclick = function(){
                item.classList.add('show');
                inpItem.setAttribute('type', 'text'); 
            }
            eyeShow.onclick = function(){
                item.classList.remove('show');
                inpItem.setAttribute('type', 'password');
            }
        }
    })
}